import React from "react";

import * as FormControl from "lib/components/FormControl";
import CSSModules from "lib/utils/css-modules";
import makeFormGroup from "lib/components/FormControl/utils/makeFormGroup";
import styles from "./PricingPlansField.less";

@CSSModules(styles)
class PricingPlansField extends React.Component {
  handleCheckboxChange(pricingPlanOption, checked) {
    const { pricingPlans, onChange } = this.props;
    const nextPricingPlans = checked
      ? [...pricingPlans, { ...pricingPlanOption, amount: null }]
      : pricingPlans.filter(({ id }) => id !== pricingPlanOption.id);
    onChange(nextPricingPlans);
  }

  handleAmountChange(id, valueObj) {
    const amount = valueObj === null ? null : valueObj.value;
    const { pricingPlans, onChange } = this.props;
    const nextPricingPlans = pricingPlans.map((pricingPlan) =>
      pricingPlan.id === id ? { ...pricingPlan, amount } : pricingPlan
    );
    onChange(nextPricingPlans);
  }

  render() {
    const { pricingPlansOptions, pricingPlans, errors } = this.props;
    const pricingPlansById = pricingPlans.reduce((obj, pricingPlan) => {
      obj[pricingPlan.id] = pricingPlan;
      return obj;
    }, {});

    return (
      <div styleName="options">
        {pricingPlansOptions.map((pricingPlanOption) => {
          const { id, name, currency } = pricingPlanOption;
          const checked = id in pricingPlansById;
          const amount = checked ? pricingPlansById[id].amount : null;
          return (
            <div key={`pricingPlan_${id}`} styleName="option">
              <FormControl.CheckboxFormGroup
                checked={checked}
                onChange={this.handleCheckboxChange.bind(this, pricingPlanOption)}
                label={name}
              />
              <FormControl.MoneyFormGroup
                {...FormControl.addProps(`accommodation.schedule.pricingPlanAmount[${id}]`, { errors })}
                inlineLabel
                value={{ value: amount, currency }}
                onChange={this.handleAmountChange.bind(this, id)}
                currencyEditable={false}
                defaultCurrency={currency}
                disabled={!checked}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default makeFormGroup(PricingPlansField);



// WEBPACK FOOTER //
// ./src/modules/accommodation/AccommodationSchedulerView/PricingPlansField.jsx